import React, {useEffect, useState} from "react";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {CheckboxControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";
import {EmailInputWithVerification, useEmailVerificationApiError} from "@pg-rp/email-with-verification";

import {useVerifyEmailQuery} from "../../../email_verification/api/email_verification_api";
import {useSubscribeToNewsletter} from "../../../newsletter/hooks/useSubscribeToNewsletter";

export const ArticleNotificationsSubscription = () => {
    const formMethods = useForm({defaultValues, resolver: yupResolver(validationSchema)});
    const {subscribeToNotifications} = useSubscribeToNewsletter();
    const {handleSubmit, setError} = formMethods;

    const [email, setEmail] = useState<string | null>(null);
    const {data, error, isLoading, isFetching} = useVerifyEmailQuery({email: email || ""}, {skip: !email});
    const apiError = useEmailVerificationApiError({errorData: error});

    useEffect(() => {
        if (!apiError.isValid) {
            setError("email", {message: apiError.message});
        }
    }, [apiError]);

    const disableSubmitButton = !data || formMethods.formState.isSubmitting || isLoading || isFetching || !isEmpty(formMethods.formState.errors);

    const onSubmit = async (values: typeof defaultValues) => {
        await subscribeToNotifications(
            {
                email: values.email,
                email_marketing_consent: values.consent,
                phone_marketing_consent: false
            },
            true
        );
    };

    return (
        <div className={newsletterWrapper}>
            <Text variant="headline_4" as="p" mb={2} fontFamily="secondary">
                Zapisz się do Newslettera
            </Text>
            <Text variant="body_copy_2" mb={2}>
                Bądź na bieżąco! Otrzymuj poradniki, analizy i aktualności o nieruchomościach z RynekPierwotny.pl na swoją skrzynkę e-mail.
            </Text>
            <FormProvider {...formMethods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={formInputWrapper}>
                        <div className={css({flex: 1, width: "100%"})}>
                            <EmailInputWithVerification verificationData={data} verificationTrigger={setEmail} placeholder="Twój email" />
                        </div>
                        <Button variant="filled_primary" type="submit" size="small" className={buttonStyle} disabled={disableSubmitButton}>
                            Wyślij
                        </Button>
                    </div>
                    <CheckboxControlled
                        name="consent"
                        labelContent="Chcę otrzymywać mailem oferty z RynekPierwotny.pl. Zgodę mogę zawsze odwołać."
                        checkedMarkColor="#02D054"
                    />
                </form>
            </FormProvider>
        </div>
    );
};

const defaultValues = {email: "", consent: false};

const validationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    consent: Yup.boolean().isTrue("Wyraź zgodę żeby otrzymywać powiadomienia.")
});

const newsletterWrapper = css({
    padding: 2,
    backgroundColor: "var(--colors-background-100)",
    borderRadius: 2
});

const formInputWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1,
    mb: 1,

    md: {
        flexDirection: "row",
        mb: 2
    }
});

const buttonStyle = css({
    width: "100%",

    md: {flexBasis: "200px"}
});
import React, {useEffect, useState} from "react";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {CheckboxControlled} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";
import {EmailInputWithVerification, useEmailVerificationApiError} from "@pg-rp/email-with-verification";

import {useVerifyEmailQuery} from "../../../email_verification/api/email_verification_api";
import {useSubscribeToNewsletter} from "../../../newsletter/hooks/useSubscribeToNewsletter";

export const ArticleNotificationsSubscription = () => {
    const formMethods = useForm({defaultValues, resolver: yupResolver(validationSchema)});
    const {subscribeToNotifications} = useSubscribeToNewsletter();
    const {handleSubmit, setError} = formMethods;

    const [email, setEmail] = useState<string | null>(null);
    const {data, error, isLoading, isFetching} = useVerifyEmailQuery({email: email || ""}, {skip: !email});
    const apiError = useEmailVerificationApiError({errorData: error});

    useEffect(() => {
        if (!apiError.isValid) {
            setError("email", {message: apiError.message});
        }
    }, [apiError]);

    const disableSubmitButton = !data || formMethods.formState.isSubmitting || isLoading || isFetching || !isEmpty(formMethods.formState.errors);

    const onSubmit = async (values: typeof defaultValues) => {
        await subscribeToNotifications(
            {
                email: values.email,
                email_marketing_consent: values.consent,
                phone_marketing_consent: false
            },
            true
        );
    };

    return (
        <div className={newsletterWrapper}>
            <Text variant="headline_4" as="p" mb={2} fontFamily="secondary">
                Zapisz się do Newslettera
            </Text>
            <Text variant="body_copy_2" mb={2}>
                Bądź na bieżąco! Otrzymuj poradniki, analizy i aktualności o nieruchomościach z RynekPierwotny.pl na swoją skrzynkę e-mail.
            </Text>
            <FormProvider {...formMethods}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={formInputWrapper}>
                        <div className={css({flex: 1, width: "100%"})}>
                            <EmailInputWithVerification verificationData={data} verificationTrigger={setEmail} placeholder="Twój email" />
                        </div>
                        <Button variant="filled_primary" type="submit" size="small" className={buttonStyle} disabled={disableSubmitButton}>
                            Wyślij
                        </Button>
                    </div>
                    <CheckboxControlled
                        name="consent"
                        labelContent="Chcę otrzymywać mailem oferty z RynekPierwotny.pl. Zgodę mogę zawsze odwołać."
                        checkedMarkColor="#02D054"
                    />
                </form>
            </FormProvider>
        </div>
    );
};

const defaultValues = {email: "", consent: false};

const validationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    consent: Yup.boolean().isTrue("Wyraź zgodę żeby otrzymywać powiadomienia.")
});

const newsletterWrapper = css({
    padding: 2,
    backgroundColor: "var(--colors-background-100)",
    borderRadius: 2
});

const formInputWrapper = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: 1,
    mb: 1,

    md: {
        flexDirection: "row",
        mb: 2
    }
});

const buttonStyle = css({
    width: "100%",

    md: {flexBasis: "200px"}
});
